import { ECarriersList } from './Carrier';

export enum SECTIONS {
	RADIO_MEMBER_SELECTION = 'radioMemberSelection',
	NEWCLAIM_TYPE_OF_SERVICE = 'selectedPage.steps.typeOfService',
	NEWCLAIM_PRESCRIPTION = 'selectedPage.steps.prescription',
	NEWCLAIM_PRICE_ESTIMATE = 'selectedPage.steps.priceEstimate',
	NEWCLAIM_INVOICE = 'selectedPage.steps.invoice',
	NEWCLAIM_CALCULATE_TAX_COLUMNS = 'newClaimCalculateTaxColumns',
	ENABLE_CLAIM_REJECTION_DEFAULT_FIELDS = 'claimRejectionDefaultFields',
	ENABLE_CLAIM_REJECTION_ADDITIONAL_FIELDS = 'claimRejectionAdditionalFields',
	PSWT_AMOUNT = 'pswtAmount',
	FISCAL_CODE = 'fiscalCode',
	PPS_CODE = 'ppsCode',
	FISCAL_CODE_RADIO = 'notPpsCode',
	VISUS_CHANGE = 'visusChange',
}

export type SectionsListConfig = {
	[k in SECTIONS]: boolean;
};

export const SECTIONS_VISIBILITY_CONFIG: {
	[k in ECarriersList]: SectionsListConfig;
} = {
	[ECarriersList.FASCHIM_CARRIER]: {
		[SECTIONS.RADIO_MEMBER_SELECTION]: false,
		[SECTIONS.NEWCLAIM_TYPE_OF_SERVICE]: true,
		[SECTIONS.NEWCLAIM_PRESCRIPTION]: true,
		[SECTIONS.NEWCLAIM_PRICE_ESTIMATE]: true,
		[SECTIONS.NEWCLAIM_INVOICE]: true,
		[SECTIONS.NEWCLAIM_CALCULATE_TAX_COLUMNS]: true,
		[SECTIONS.ENABLE_CLAIM_REJECTION_DEFAULT_FIELDS]: true,
		[SECTIONS.ENABLE_CLAIM_REJECTION_ADDITIONAL_FIELDS]: false,
		[SECTIONS.PSWT_AMOUNT]: false,
		[SECTIONS.FISCAL_CODE]: true,
		[SECTIONS.PPS_CODE]: false,
		[SECTIONS.FISCAL_CODE_RADIO]: true,
		[SECTIONS.VISUS_CHANGE]: true,
	},
	[ECarriersList.DEFAULT_CARRIER]: {
		[SECTIONS.RADIO_MEMBER_SELECTION]: true,
		[SECTIONS.NEWCLAIM_TYPE_OF_SERVICE]: true,
		[SECTIONS.NEWCLAIM_PRESCRIPTION]: true,
		[SECTIONS.NEWCLAIM_PRICE_ESTIMATE]: true,
		[SECTIONS.NEWCLAIM_INVOICE]: false,
		[SECTIONS.NEWCLAIM_CALCULATE_TAX_COLUMNS]: false,
		[SECTIONS.ENABLE_CLAIM_REJECTION_DEFAULT_FIELDS]: true,
		[SECTIONS.ENABLE_CLAIM_REJECTION_ADDITIONAL_FIELDS]: false,
		[SECTIONS.PSWT_AMOUNT]: false,
		[SECTIONS.FISCAL_CODE]: true,
		[SECTIONS.PPS_CODE]: false,
		[SECTIONS.FISCAL_CODE_RADIO]: true,
		[SECTIONS.VISUS_CHANGE]: true,
	},
	[ECarriersList.CHUBB_CARRIER]: {
		[SECTIONS.RADIO_MEMBER_SELECTION]: true,
		[SECTIONS.NEWCLAIM_TYPE_OF_SERVICE]: true,
		[SECTIONS.NEWCLAIM_PRESCRIPTION]: true,
		[SECTIONS.NEWCLAIM_PRICE_ESTIMATE]: true,
		[SECTIONS.NEWCLAIM_INVOICE]: true,
		[SECTIONS.NEWCLAIM_CALCULATE_TAX_COLUMNS]: false,
		[SECTIONS.ENABLE_CLAIM_REJECTION_DEFAULT_FIELDS]: false,
		[SECTIONS.ENABLE_CLAIM_REJECTION_ADDITIONAL_FIELDS]: true,
		[SECTIONS.PSWT_AMOUNT]: false,
		[SECTIONS.FISCAL_CODE]: true,
		[SECTIONS.PPS_CODE]: false,
		[SECTIONS.FISCAL_CODE_RADIO]: true,
		[SECTIONS.VISUS_CHANGE]: true,
	},
	[ECarriersList.DECARE]: {
		[SECTIONS.RADIO_MEMBER_SELECTION]: true,
		[SECTIONS.NEWCLAIM_TYPE_OF_SERVICE]: true,
		[SECTIONS.NEWCLAIM_PRESCRIPTION]: true,
		[SECTIONS.NEWCLAIM_PRICE_ESTIMATE]: true,
		[SECTIONS.NEWCLAIM_INVOICE]: true,
		[SECTIONS.NEWCLAIM_CALCULATE_TAX_COLUMNS]: false,
		[SECTIONS.ENABLE_CLAIM_REJECTION_DEFAULT_FIELDS]: true,
		[SECTIONS.ENABLE_CLAIM_REJECTION_ADDITIONAL_FIELDS]: false,
		[SECTIONS.PSWT_AMOUNT]: true,
		[SECTIONS.FISCAL_CODE]: false,
		[SECTIONS.PPS_CODE]: true,
		[SECTIONS.FISCAL_CODE_RADIO]: false,
		[SECTIONS.VISUS_CHANGE]: false,
	},
};
